import React from "react";
import Loading from "../../components/common/loading";
import InfoPopover from "../../components/common/infoPopover";
// import icons from '../../../assets/icon-all';
import { Link } from "react-router-dom";
import ModalManager from "../../components/common/modal/ModalManager";
import NotificationManager from '../../utils/notificationManager';
import TextInput from "../../components/common/inputs/textInput";
// import Pagination from "../../components/common/pagination";
import ReactPaginate from "react-paginate";
import axios from "axios";

// import { formatDistance } from "date-fns";

const columnWidths = [
  1, // connection icon
  3, // Model Number
  2, // Device Name
  4, // outlets
  2, // kwh
  3, // amps
  3, // alerts
  3, // serial
  6, // info
  2, // timestamp BUTTON
  1, // refresh
];

const RenderDeviceLineItem = (passedProps) => (
  <DeviceLineItem {...passedProps.parentProps} device={passedProps.item} />
);

const palette = {
  green: "#2ecc71",
  red: "#e74c3c",
  grey: "#95a5a6",
};

class DevicesSummary extends React.Component {
  state = { dark: document.body.classList.contains("dark-mode") };

  componentDidMount() {
    this.darkObserver = new MutationObserver(() => {
      this.setState({ dark: document.body.classList.contains("dark-mode") });
    });
    this.darkObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  }

  componentWillUnmount() {
    this.darkObserver && this.darkObserver.disconnect();
  }

  Tile = ({ label, value, color, info, link }) => {
    const { dark } = this.state;
    return (
      <div style={tile.wrap(dark)} className="devices-summary-tile">
        <div style={tile.big(dark)}>{value}</div>
        <div style={tile.label(dark)}>
          {link ? (
            <Link to={link} style={tile.linkLabel(dark)}>
              {label}
            </Link>
          ) : (
            <span>{label}</span>
          )}
          {info && <InfoPopover text={info} />}
        </div>
        <div style={{ ...tile.accent, background: color, width: "100%" }} />
      </div>
    );
  };

  SkeletonTile = ({ color }) => {
    const { dark } = this.state;
    return (
      <div className="skeleton-blank" style={skeleton.tile(dark)}>
        <div style={{ ...tile.accent, background: color, width: "100%" }} />
      </div>
    );
  };

  render() {
    const meta = this.props.meta || {};
    const summary = this.props.summary || {};
    const total = meta.totalCount;
    const online = meta.onlineCount;
    const offline = meta.offlineCount;
    const { activeTriggers, recentTriggers, outletActions } = summary;
    const groupId = this.props.groupId;

    const tiles = [
      {
        key: "total",
        label: "Total PDUs",
        value: total,
        color: palette.grey,
        // info: "Total number of PDUs allocated to you",
      },
      {
        key: "online",
        label: "Online",
        value: online,
        color: palette.green,
        // info: "Devices currently online",
      },
      {
        key: "offline",
        label: "Offline",
        value: offline,
        color: palette.grey,
        // info: "Devices currently offline",
      },
      {
        key: "currentAlerts",
        label: "Current Alerts",
        value: activeTriggers,
        color: palette.red,
        info: "Devices with alerts triggered now",
        link: groupId ? `/devices/groups/${groupId}/alerts` : "/devices/alerts",
      },
      {
        key: "alerts24",
        label: "Alerts (24h)",
        value: recentTriggers,
        color: palette.red,
        info: "Alerts triggered in the last 24 hours",
        link: groupId ? `/devices/groups/${groupId}/event-logs` : "/activity/notifications",
      },
      {
        key: "reboots24",
        label: "Outlet Reboots (24h)",
        value: outletActions,
        color: palette.green,
        info: "Outlet switches in the last 24 hours",
        link: groupId ? `/devices/groups/${groupId}/activity-log` : "/activity/history",
      },
    ];

    if (tiles.some((t) => t.value === undefined)) {
      return (
        <div style={st.grid}>
          {tiles.map((t) => (
            <this.SkeletonTile key={t.key} color={t.color} />
          ))}
        </div>
      );
    }

    return (
      <div style={st.grid}>
        {tiles.map((t) => (
          <this.Tile key={t.key} {...t} />
        ))}
      </div>
    );
  }
}

const st = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
    gap: 16,
    marginBottom: "30px"
  },
  center: {
    textAlign: "center",
    margin: "48px 0",
    color: "#555",
  },
};

const tile = {
  wrap: (dark) => ({
    background: dark ? "#424242" : "#fff",
    borderRadius: 3,
    padding: "20px 16px 12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    position: "relative",
    minHeight: 92,
  }),
  big: (dark) => ({
    fontSize: 28,
    fontWeight: 600,
    lineHeight: 1,
    color: dark ? "#f3f3f3" : "#2c3e50",
  }),
  label: (dark) => ({
    fontSize: 13,
    marginTop: 4,
    color: dark ? "#ccc" : "#7f8c8d",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }),
  linkLabel: (dark) => ({
    textDecoration: "underline",
    color: dark ? "#ccc" : "#7f8c8d",
  }),
  accent: {
    position: "absolute",
    left: 0,
    bottom: 0,
    height: 4,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    transition: "width .4s ease",
  },
};

const skeleton = {
  tile: (dark) => ({
    ...tile.wrap(dark),
    background: dark ? "#555" : "rgb(230,230,230)",
    marginTop: 0,
    marginBottom: 0,
    padding: 0,
    boxShadow: "none",
  }),
};

export default class DeviceConnected extends React.Component {
  componentDidMount() {
    this.props.fetchResourcePaginate("devices", undefined, {
      page: 1,
      ...this.props.queryParams
    }, true, )
    this.fetchSummary();
  }
  state = {
    search: "",
    connectionState: "",
    sortBy: "",
    sortDir: "",

    exporting: false,
    summary: null,


  };
  csvExport = (cb = (err) => {}) => {
    // use modal manager to confirm export
    // eventualy, will have options to configure here, such as choose which columns
      const {
    search,
    connectionState,
    sortBy,
    sortDir,
  } = this.state;

  // include any “static” query params passed from parent (e.g. groupId)
  const inheritedParams = this.props.queryParams || {};

  const params = new URLSearchParams({
    ...inheritedParams,
    search,
    connectionState,
    sortBy,
    sortDir,
  });

  this.setState({ exporting: true });
  NotificationManager.info("Exporting devices to CSV. This may take a few minutes if there are many devices");
  fetch(`/v2/devices/export.csv?${params.toString()}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  })
    .then((res) => {
      if (!res.ok) {
      NotificationManager.alert("CSV export failed – please try again.");
      
        throw new Error("export failed");
      }
      cb(true)
      return res.blob();

    })
    .then((blob) => {
      /* Excel likes a UTF-8 BOM; prepend one so UTF-8 stays intact */
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const csvBlob = new Blob([bom, blob], { type: "text/csv" });

      /* 1)  If you imported FileSaver above: */
      // saveAs(csvBlob, "devices-outlets.csv");

      /* 2)  Otherwise vanilla download: */
      const url = window.URL.createObjectURL(csvBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "devices-outlets.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch((err) => {
      console.error(err);
      cb(true)
      NotificationManager.alert("CSV export failed – please try again.");
      // alert("CSV export failed – please try again.");
    })
    .finally(() => {
      cb(false)
      NotificationManager.success("CSV export complete");
      this.setState({ exporting: false });
    });
  }
  refreshDevice = (enclosureSerialNumber) => {
    this.props.getDeviceItemAndData(enclosureSerialNumber);
  };
  fetchSummary = () => {
    const params = this.props.queryParams || {};
    axios
      .get("/v2/devices/summary", {
        params,
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((res) => this.setState({ summary: res.data.data || res.data }))
      .catch((err) => console.error(err));
  };
  applyStatusFilter = (status) => {
    this.setState({
      connectionState: status
    }, () => {

      this.fetchPage()
    })
  };
  applySearch = () => {
    const searchTerm = this.state.search;
    this.fetchPage()
  }
  applySort = (sortOption) => {
    const sortBy = sortOption.split("_")[0];
    const sortDir = sortOption.split("_")[1];
    this.setState({
      sortBy,
      sortDir
    }, () => {
      this.fetchPage()
    })
  }
  fetchPage = () => {
    const {
      sortBy,
      sortDir,
      connectionState,
      search
    } = this.state;

    const passedQueryParams = this.props.queryParams || {};

    const queryParams = {
      page: 1,
      search,
      ...passedQueryParams
    }
    if (sortBy) queryParams.sortBy = sortBy;
    if (sortDir) queryParams.sortDir = sortDir;
    if (connectionState) queryParams.connectionState = connectionState;

    this.props.fetchResourcePaginate("devices", undefined, queryParams, true)
  }
  editDeviceName = (device) => {
    ModalManager.confirm(
      "",
      `${device.modelNumber} PDU (SN:${device.enclosureSerialNumber})`,
      "Edit",
      (submitted, close) => {
        if (submitted) {
          close();
        }
      },
      ({ close }) => (
        <EditDeviceForm
          updateDeviceItem={this.props.updateDeviceItem}
          device={device}
          close={close}
        />
      ),
      true,
      true
    );
  };
  render() {
    // const {
    //   devices = [],
    //   devicesLoading,
    // } = this.props.resources;

    const { addGroupDeviceActive } = this.props;
    const updateDeviceItem = this.props.updateDeviceItem

    const sortOptions = [
      { label: "Default", value: "" },
      { label: "Device Name A-Z", value: "deviceName_asc" },
      { label: "Device Name Z-A", value: "deviceName_desc" },
      { label: "Serial Number ↑", value: "enclosureSerialNumber_asc" },
      { label: "Serial Number ↓", value: "enclosureSerialNumber_desc" },
    ]; 


    return (
      <div style={{ marginTop: "2vh", overflowX: "auto" }}>
        <DevicesSummary
          meta={this.props.resources.devicesMeta}
          summary={this.state.summary}
          groupId={this.props.queryParams?.groupId}
        />
        <div className="grid-x ">
          <div className="cell large-6 medium-6 small-12">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <input
                type="text"
                placeholder="Search for model number, device name, or serial number"
                value={this.state.search}
                onChange={(e) => {
                  this.setState({ search: e.target.value });
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    this.applySearch();
                  }
                }}
              />
              <span
                className="search-icon-button"
                style={{ margin: "0 0 1rem" }}
                onClick={() => {
                  this.applySearch();
                }}
              >
                <i className="material-icons">search</i>
              </span>
            </div>
          </div>
          {addGroupDeviceActive && this.props.match.params.groupId && (
            <div
              className="cell large-6 medium-6 small-12"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Link
                to={`/devices/groups/${this.props.match.params.groupId}/devices/edit`}
                style={{ color: "white" }}
              >
                <div className="button">Manage group devices</div>
              </Link>
            </div>
          )}
        </div>
        <div className="grid-x">
          <div className="cell large-6">
            <div style={{ display: "flex" }}>
              <span style={{ marginRight: "20px" }}>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#6b6b6b",
                    marginBottom: "5px",
                    marginLeft: "3px",
                  }}
                >
                  Filter by
                </div>
                <select
                  style={{
                    margin: "0px",
                  }}
                  onChange={(e) => {
                    this.applyStatusFilter(e.target.value)
                  }}
                >
                  <option value="">All Status</option>
                  <option label="Connected" value="connected">Connected</option>
                  <option label="Disconnected" value="disconnected">Disconnected</option>
                </select>
              </span>
              <span>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#6b6b6b",
                    marginBottom: "5px",
                    marginLeft: "3px",
                  }}
                >
                  Sort by
                </div>
                <select
                  onChange={(e) => {
                    this.applySort(e.target.value)
                  }}
                >
                  {sortOptions.map((option, i) => {
                    return (
                      <option key={i} value={option.value}>
                        {option.label}
                      </option>
                    );
                  })}
                </select>
              </span>
            </div>
          </div>
          <div
            className="cell large-6"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div
              // className="button"
            >
              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  if (this.state.exporting) return; // prevent multiple clicks
                  ModalManager.confirm(
                    <ExportPreview
                      search={this.state.search}
                      connectionState={this.state.connectionState}
                      sortBy={this.state.sortBy}
                      sortDir={this.state.sortDir}
                      columns={[
                        "Device ID",
                        "Device Name",
                        "Connection State",
                        "Outlet Number",
                        "Outlet ID",
                        "Outlet Name",
                        "Outlet Status",
                        "Outlet Current RMS",
                        "Last Updated",
                        "Inlet #1 Current RMS",
                        "Inlet #1 Voltage",
                        "Inlet #1 Line Frequency",
                        "Inlet #1 Power Factor",
                        "Inlet #1 Active Power",
                        "Inlet #1 Apparent Power",
                        "Inlet #1 Energy Accum kWh",
                      ]}
                    />,
                    "Export Devices",
                    "Export",
                    (confirmed, close) => {
                      if (!confirmed) return;
                      this.csvExport((err) => {
                        close();
                      });
                    }
                  );

                }}
              >
                {this.state.exporting ? (
                  <Loading black />
                ) : (
                  <>
                    CSV Export
                   <i className="material-icons" style={{margin: "0px", marginLeft: "5px"}}>download</i>

                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <PaginatedList
          resourceName="devices"
          pages={this.props.resources.devicesPages}
          resetPages={() => this.props.resetResourcePages("devices")}
          pageLoading={this.props.resources.devicesPageLoading}
          fetchResourcePaginate={this.props.fetchResourcePaginate}
          totalItemCount={this.props.resources.devicesMeta.totalCount || undefined}
          hideSearch={true}
          showSummary
          itemLabel="devices"

          queryParams={{
            search: this.state.search,
            connectionState: this.state.connectionState,
            sortBy: this.state.sortBy,
            sortDir: this.state.sortDir,
            ...this.props.queryParams
          }}
          resetKey={this.props.resources.devicesPaginationResetKey}
          LoadingProp={() => (
            <div>
              {[null, null, null, null].map((item, index) => {
                return (
                  <div className="grid-row-wrapper" key={index}>
                    <div className="grid-row">
                      <div style={{ flex: columnWidths[0] }}></div>
                      <div style={{ flex: columnWidths[1] }}>
                        <div className="skeleton-blank" />
                      </div>
                      <div style={{ flex: columnWidths[2] }}>
                        <div className="skeleton-blank" />
                      </div>
                      <div style={{ flex: columnWidths[3] }}>
                        <div className="skeleton-blank" />
                      </div>
                      <div style={{ flex: columnWidths[4] }}>
                        <div className="skeleton-blank" />
                      </div>
                      <div style={{ flex: columnWidths[10] }}></div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          parentProps={{
            ...this.props,
            refreshDevice: this.refreshDevice,
            editDeviceName: this.editDeviceName,
            updateDeviceItem: updateDeviceItem,
          }}
          ItemRenderer={RenderDeviceLineItem}
          renderHeader={() => (
            <div className={`grid-row header large-only`}>
              <div style={{ flex: columnWidths[0] }}></div>
              <div style={{ flex: columnWidths[1] }}>Model Number</div>
              <div style={{ flex: columnWidths[2] }}>Serial number</div>
              <div style={{ flex: columnWidths[3] }}>Device Name</div>
              <div style={{ flex: columnWidths[4] }}>IP Address</div>
              {/* <div style={{ flex: columnWidths[9] }}>Last Update</div> */}
              <div style={{ flex: columnWidths[10] }}></div>
            </div>
          )}
        />
       
      </div>
    );
  }
}



class DeviceLineItem extends React.Component {
  state = {
    conf: null,
    confLoading: false,
  }
  componentDidMount() {
    this._isMounted = true;
    if (this.props.device.connectionState === "Connected") {
      this.grabConf({ cache: true });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
    if (this._axiosCancelSource) {
      this._axiosCancelSource.cancel("DeviceLineItem unmounted");
    }
  }

//   componentDidUpdate(prevProps) {
//   if (
//     prevProps.device.enclosureSerialNumber !==
//     this.props.device.enclosureSerialNumber
//   ) {
//     this.grabConf();            // fetch when device *actually* changes
//   }
// }
  // ────────────────────────────
  // private helpers / flags
  // ────────────────────────────
  _axiosCancelSource = null;   // holds current cancel token
  _isMounted         = false;  // prevents setState on unmounted component

  grabConf = ({ cache }) => {
    // cancel any previous request before starting a new one
    if (this._axiosCancelSource) {
      this._axiosCancelSource.cancel("superseded request");
    }
    this._axiosCancelSource = axios.CancelToken.source();

    this.setState({ confLoading: true });

    const isLte = this.props.device?.modelNumber?.endsWith("M01");
    const useCache = cache && !isLte;

    axios
      .get(
        `/v2/conf?${useCache ? "cache=true" : "cache=false"}&enclosure_serial_number=${this.props.device.enclosureSerialNumber}`,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
          cancelToken: this._axiosCancelSource.token,
        }
      )
      .then((res) => {
        if (!this._isMounted) return;      // component already unmounted
        this.setState({
          conf: (res.data?.data || [])[0],
          confLoading: false,
        });
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;   // silently ignore
        console.error(err);
        if (this._isMounted) {
          this.setState({ confLoading: false });
        }
      });
  };

  render() {
    const props = this.props;
      const { device, i } = props;

    const deviceLoading = props.resources.devices.find(d => d.enclosureSerialNumber == device.enclosureSerialNumber)?.loading;
    let ipAddress = "";
    if (this.state.conf) {
      if (this.state.conf.ipAssign === "dhcp" && this.state.conf.dhcpAssignedIp) {
        ipAddress = this.state.conf.dhcpAssignedIp;
      } else if (this.state.conf.ipAssign === "static" && this.state.conf.staticIp) {
        ipAddress = this.state.conf.staticIp;
      } else {
        ipAddress = "-";
      }
    }
    const defaultRouteLabel = (() => {
      const route = this.state.conf?.currentDefaultRoute || "";
      if (route.includes("ppp")) return "LTE";
      if (route.includes("eth")) return "Ethernet";
      return "";
    })();
    const isLtePdu = typeof this.state.conf?.enableCellular !== "undefined";


  const series = (() => {
    if (device.modelNumber) {
      if (
        device.outletPwrMeasurementsSupported &&
        device.outletSwitchingSupported
        // device.inletEnergySupported
      ) {
        return "SynLink Switched Pro+";
      } else if (
        // device.inletEnergySupported &&
        !device.outletPwrMeasurementsSupported &&
        !device.outletSwitchingSupported
      ) {
        return "SynLink Monitored";
      } else if (
        device.inletCurrentSupported &&
        device.outletSwitchingSupported
      ) {
        if (device.modelNumber.startsWith("NP")) {
          return "NetBooter";
        } else {
          return "SynLink Switched";
        }
      } else {
        return "";
      }
    } else {
      return "";
    }
  })();
  const modelLine = device.modelNumber
    ? `${series === "NetBooter" ? "" : device.formFactor} ${series}${
        series === "NetBooter" ? " PDU" : ""
      }${device.modelNumber.endsWith("M01") ? " LTE" : ""}`
    : props.resources.devicesLoaded
    ? "-"
    : "";
  const connectionEstablished = device.connectionState === "Connected";
  const statusIcon = connectionEstablished ? "cloud_done" : "cloud_off";
  const statusLabel = connectionEstablished ? "Online" : "Offline";
  const handleRefresh = () => {
    props.refreshDevice(device.enclosureSerialNumber);
    this.grabConf({ cache: false });
  };
  const ipDisplay = this.state.confLoading ? (
    <div className="skeleton-blank" />
  ) : (
    <span>
      {ipAddress && ipAddress !== "-" ? (
        <>
          <a
            href={`http://${ipAddress}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "underline",
            }}
          >
            {ipAddress}
          </a>
          {isLtePdu && defaultRouteLabel && (
            <span style={{ marginLeft: "5px", fontSize: "90%" }}>
              ({defaultRouteLabel})
            </span>
          )}
        </>
      ) : (
        <span style={{ color: "" }}>{ipAddress}</span>
      )}
    </span>
  );
  const desktopRefreshAction = deviceLoading ? (
    <Loading black />
  ) : (
    <span
      title="Refresh PDU Information"
      className="black"
      style={{
        cursor: "pointer",
      }}
      onClick={handleRefresh}
    >
      <i style={{ fontWeight: "600", color: "#6c6f72" }} className="material-icons">
        sync
      </i>
    </span>
  );
  return (
    <div
      key={i}
      className={`grid-row-wrapper ${
        device.connectionState === "Connected" ? "" : "disconnected"
      }`}
      title={
        device.connectionState === "Connected" ? "" : "Disconnected"
      }
    >
      <div
        className={`grid-row large-only ${
          connectionEstablished ? "connected" : "disconnected"
        }`}
      >
        <div
          style={{
            fontWeight: "600",
            flex: columnWidths[0],
            color: connectionEstablished ? "forestgreen" : "maroon",
          }}
          // className={connectionEstablished ? 'green' : 'red'}
          title={
            connectionEstablished
              ? "Connection Established"
              : "Connection Cannot Be Made"
          }
        >
          <i className="material-icons" style={{ marginLeft: "4px" }}>
            {statusIcon}
          </i>
        </div>
        <div
          style={{
            flex: columnWidths[1],
          }}
        >
          <Link
            to={`/devices/connected/${device.enclosureSerialNumber}`}
          >
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  textDecoration: "underline",
                }}
              >
                <b>
                  {device.modelNumber
                    ? device.modelNumber.startsWith("NP")
                      ? device.modelNumber
                      : `SP-${device.modelNumber}`
                    : "-"}
                </b>
              </span>
              <span>{modelLine}</span>
            </span>
          </Link>
        </div>

        <div
          style={{
            // color: "rgba(0,0,0,0.7)",
            flex: columnWidths[2],
            // display: 'flex',
            // flexDirection: 'column',
            // alignItems: 'flex-start'
          }}
        >
          {device.enclosureSerialNumber}
        </div>
        <div
          style={{
            flex: columnWidths[3],
          }}
        >
          <span
            className="hover-show"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => {
              props.editDeviceName(device);

            }}
          >
            <span>{device.deviceName}</span>
            <span className="hover-item">
              <i className="material-icons">edit</i>
            </span>
          </span>
        </div>

        <div
          style={{
            flex: columnWidths[4],
            // fontWeight: "600",
          }}
        >
          {ipDisplay}
        </div>
        {/* <div style={{ flex: columnWidths[9] }}>
          <span
            style={{
              fontSize: "90%",
            }}
          >
            {device.lastUpdated &&
              `${formatDistance(device.lastUpdated, new Date())} ago`}
          </span>
        </div> */}
        <div style={{ flex: columnWidths[10] }}>
          {desktopRefreshAction}
        </div>
      </div>
      <div
        className={`device-card small-only ${
          connectionEstablished ? "" : "device-card--offline"
        }`}
      >
        <div className="device-card__header">
          <div className="device-card__status" title={statusLabel}>
            <i className="material-icons" aria-hidden="true">
              {statusIcon}
            </i>
            <span className="device-card__status-label">{statusLabel}</span>
          </div>
          <div className="device-card__actions">
            {deviceLoading ? (
              <Loading black />
            ) : (
              <button
                type="button"
                className="device-card__icon-button"
                aria-label="Refresh PDU information"
                onClick={handleRefresh}
              >
                <i className="material-icons" aria-hidden="true">
                  sync
                </i>
              </button>
            )}
          </div>
        </div>
        <div className="device-card__model">
          <Link to={`/devices/connected/${device.enclosureSerialNumber}`}>
            <span className="device-card__model-code">
              {device.modelNumber
                ? device.modelNumber.startsWith("NP")
                  ? device.modelNumber
                  : `SP-${device.modelNumber}`
                : "-"}
            </span>
            {modelLine && (
              <span className="device-card__model-detail">{modelLine}</span>
            )}
          </Link>
        </div>
        <div className="device-card__meta">
          <div className="device-card__field">
            <span className="device-card__label">Serial Number</span>
            <div className="device-card__value">{device.enclosureSerialNumber}</div>
          </div>
          <div className="device-card__field">
            <span className="device-card__label">Device Name</span>
            <div className="device-card__value device-card__value--with-action">
              <span>{device.deviceName}</span>
              <button
                type="button"
                className="device-card__icon-button"
                aria-label="Edit device name"
                onClick={() => {
                  props.editDeviceName(device);
                }}
              >
                <i className="material-icons" aria-hidden="true">
                  edit
                </i>
              </button>
            </div>
          </div>
        </div>
        <div className="device-card__field">
          <span className="device-card__label">IP Address</span>
          <div className="device-card__value">{ipDisplay}</div>
        </div>
      </div>
    </div>
  );
  }
}


class EditDeviceForm extends React.Component {
  state = {
    deviceName: "",
    loading: false,
  };
  componentDidMount() {
    this.setState({
      deviceName: this.props.device.deviceName,
    });
  }
  render() {
    const { device, close } = this.props;

    return (
      <div>
        <TextInput
          label="Device Name"
          value={this.state.deviceName}
          callback={(txt) => {
            this.setState({ deviceName: txt });
          }}
          placeholder="Enter Device Name"
        />
        <button
          className="button"
          onClick={() => {
            this.setState({ loading: true });
            this.props.updateDeviceItem(device.enclosureSerialNumber, {
              deviceName: this.state.deviceName,
            }, (err, data) => {
                this.setState({ loading: false });
                if (err) {
                  console.log(err);
                } else {
                  close();
                }
            })
          }}
        >
          {this.state.loading ? <Loading /> : "Change"}
        </button>
      </div>
    );
  }
}


class PaginatedList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPageNumber: 1,       // which page we’re on (1-based)
      pageSize: 10,
      // pageLoading: {},           // object keyed by page for loading state
    };
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.resetKey !== prevProps.resetKey) {
      this.setState({ currentPageNumber: 1 });
    }
  }

  findPageInCache = (pageNumber) => {
    const { pages } = this.props;
    if (!Array.isArray(pages)) return null;
    return pages.find((p) => p.page === pageNumber);
  };

  handlePageClick = ({ selected }) => {
    const newPage = selected + 1; // react-paginate is 0-based
    this.setState({ currentPageNumber: newPage }, () => {
      this.fetchPageIfNeeded(newPage);
      this.fetchPageIfNeeded(newPage + 1);
      // this.fetchPageIfNeeded(newPage + 2);
    });
  };

  // fetchPageIfNeeded checks if we have a cached page or if we’re already loading it 
  // before calling fetchPage
  fetchPageIfNeeded = (pageNumber) => {
    const hasPageCache = this.findPageInCache(pageNumber);
    if (hasPageCache) {
      // We already have data, do nothing
      return;
    }
    // const isLoading = this.state.pageLoading[pageNumber];
    const isLoading = this.props.pageLoading[pageNumber];
    if (isLoading) {
      // console.log(`Already fetching page ${pageNumber}, skipping.`);
      return;
    }
    this.fetchPage(pageNumber);
  };

  fetchPage = (pageNumber) => {
    const { fetchResourcePaginate, resourceName, queryParams={} } = this.props;
    const { searchBar, pageSize } = this.state;

    fetchResourcePaginate(
      resourceName,
      undefined,
      {
        page: pageNumber,
        limit: pageSize,
        ...queryParams
        // search: searchBar,
      }
    );
  };

  getCurrentPageDevices = () => {
    const currentPageObj = this.findPageInCache(this.state.currentPageNumber);
    return currentPageObj ? currentPageObj.devices : [];
  };

  render() {
    const {
      totalItemCount,
      ItemRenderer,
      pageLoading,
      LoadingProp,
      queryParams,
      showSummary,
      itemLabel,
      renderHeader,
    } = this.props;
    const { currentPageNumber, pageSize } = this.state;
    // total pages
    const totalPages = totalItemCount
      ? Math.ceil(totalItemCount / pageSize)
      : 1;

    // get the devices for the current page
    const currentPageDevices = this.getCurrentPageDevices();
    // see if the current page is loading
    const currentPageIsLoading = !!pageLoading[currentPageNumber];

    // If current page is loading and we have no cached data for that page, show spinner
    const showSpinner = currentPageIsLoading && currentPageDevices.length === 0;
    const hasTotalCount = typeof totalItemCount === "number";
    const resourceLabel = itemLabel || this.props.resourceName || "items";
    let summaryText = null;

    if (showSummary && hasTotalCount && !showSpinner) {
      if (totalItemCount === 0) {
        summaryText = `Showing 0 of 0 ${resourceLabel}`;
      } else {
        const showingStart = (currentPageNumber - 1) * pageSize + 1;
        const showingEnd = Math.min(
          showingStart + currentPageDevices.length - 1,
          totalItemCount
        );

        if (currentPageDevices.length === 0) {
          summaryText = `Showing 0 of ${totalItemCount} ${resourceLabel}`;
        } else {
          summaryText = `Showing ${showingStart}-${showingEnd} of ${totalItemCount} ${resourceLabel}`;
        }
      }
    }
    const summaryContent = summaryText ? (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          color: "#6b7280",
          fontSize: "14px",
          marginBottom: "8px",
        }}
      >
        {summaryText}
      </div>
    ) : null;

    const headerContent = typeof renderHeader === "function" ? renderHeader() : null;

    return (
      <div>
        {summaryContent}
        {headerContent}

        {/* if this page is loading and no data is cached, show spinner */}
        {showSpinner && (
          LoadingProp ? (
            <LoadingProp />
          ) : (
            <div style={{ margin: "16rem 0" }}>
              <Loading black />
            </div>
          )
        )}

        {/* otherwise render the items if we have them (or partial data) */}
        {!showSpinner &&
          currentPageDevices.map((item, i) => (
            <ItemRenderer
              key={item.enclosureSerialNumber}
              item={item}
              i={i}
              parentProps={this.props.parentProps}
            />
          ))}

        {/* only show pagination if we have more than 1 page */}
        {totalPages > 1 && (
          <div style={{ marginTop: "2rem" }}>
            <ReactPaginate
              previousLabel="Previous"
              nextLabel="Next"
              breakLabel="..."
              forcePage={currentPageNumber - 1}
              pageCount={totalPages}
              onPageChange={this.handlePageClick}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              containerClassName="react-paginate"
              activeClassName="selected"
            />
          </div>
        )}
      </div>
    );
  }
}






// 1️⃣  Put this helper somewhere near the component root (or in its own file)
const ExportPreview = ({
  search,
  connectionState,
  sortBy,
  sortDir,
  columns,
}) => {
  const nice = (v, fallback = "—") => (v ? v : fallback);
  const sortLabel =
    sortBy && sortDir ? `${sortBy} (${sortDir.toUpperCase()})` : "Default";
  const hasFilters = 
    search ||
    connectionState
  return (
    <div style={{ width: 380, fontSize: 14 }}>
      {hasFilters && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 20,
            color: "grey"
          }}
        >
          <i className="material-icons">filter_list</i>
          This export has filters applied</div>
      )}
      <div
        style={{
          marginBottom: 16,
          // fontWeight: 600,
          // color: "black",
        }}
      >
        The following data will be exported to CSV with the following filters applied.
      </div>
      
      {/* Filters applied */}
      <div style={{ fontWeight: 600, marginBottom: 8 }}>Filters</div>
      <table style={{ width: "100%", marginBottom: 16 }}>
        <tbody>
          <tr>
            <td style={{ padding: "4px 0" }}>Search</td>
            <td align="right">{nice(search)}</td>
          </tr>
          <tr>
            <td style={{ padding: "4px 0" }}>Status</td>
            <td align="right">
              {nice(connectionState ? connectionState : "All")}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "4px 0" }}>Sort</td>
            <td align="right">{sortLabel}</td>
          </tr>
        </tbody>
      </table>

      {/* Column list */}
      <div style={{ fontWeight: 600, marginBottom: 8 }}>Columns</div>
      <ul style={{ margin: 0, paddingLeft: 20 }}>
        {columns.map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ul>
    </div>
  );
};